import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FormProvider, useForm } from "react-hook-form";
import { PaziaFormButton, PaziaInput, PaziaLoader } from "components/atoms";
import { useShop, shopApi, ShopFormValues } from "api/shop";
import { useToaster } from "utils";
import { PaziaFromQuill } from "components/atoms/PaziaQuill/PaziaFromQuill";
import { useState, useEffect } from "react";

export const ShopSettingsForm = () => {
  const { shop, isLoading, invalidate } = useShop();
  const { showSuccess, showError } = useToaster();
  const [isSaving, setIsSaving] = useState(false);

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      [FORM_NAMES.NAME]: shop?.name ?? "",
      [FORM_NAMES.DESCRIPTION]: shop?.description ?? "",
    },
  });
  const { handleSubmit, reset } = methods;

  // Reset form when shop data loads
  useEffect(() => {
    if (shop) {
      reset({
        [FORM_NAMES.NAME]: shop.name ?? "",
        [FORM_NAMES.DESCRIPTION]: shop.description ?? "",
      });
    }
  }, [shop, reset]);

  const onSubmit = async (data: ShopFormValues) => {
    setIsSaving(true);
    try {
      await shopApi.updateShop(data);
      showSuccess("Zapisano ustawienia sklepu");
      invalidate();
    } catch (error) {
      showError("Nie udało się zapisać ustawień sklepu");
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) return <PaziaLoader position="center" />;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="grid max-w-xl gap-4">
        <PaziaInput name={FORM_NAMES.NAME} label="Nazwa sklepu" required />
        <PaziaFromQuill name={FORM_NAMES.DESCRIPTION} label="Opis sklepu" />
        <PaziaFormButton disabled={isSaving} />
      </form>
    </FormProvider>
  );
};

const FORM_NAMES = {
  NAME: "name",
  DESCRIPTION: "description",
} as const;

const schema = yup
  .object({
    [FORM_NAMES.NAME]: yup.string().required("Nazwa sklepu jest wymagana"),
    [FORM_NAMES.DESCRIPTION]: yup.string().default(""),
  })
  .required();
